import React from "react";
import {
  TabContent,
  TabPane,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Table,
  Row,
  Col,
  CardFooter,
  Label,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input
} from "reactstrap";
import Select from "react-select";

import axios from "axios";

import { PanelHeader, Button, ImageUpload } from "components";

import { Redirect } from "react-router-dom";

import { theadcustomers, tbody } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import { validateSpanishId } from "spain-id";

const PACK = 1;
const INTERNET = 2;
const MOVIL = 3;
const OTROS = 4;
const WIFI = 21;
const FIBRA = 22;

const CONTRATO = 228;
const PLANTILLA = 227;

// STEPS
const PRODUCTOS = 0;
const TIPO_CLIENTE = 1;
const DATOS_BASICOS = 2;
const DIRECCION = 3;
const FIRMA = 4;

var productsAvailable = [
  {
      "label": "Mantenimiento número",
      "id": "1862",
      "type": 3,
      "price": "5,00 €",
      "provider": {
          "id": null,
          "name": null
      }
  },
  {
      "label": "Fijo VoIP",
      "id": "5317",
      "type": 3,
      "price": "9,00 €",
      "provider": {
          "id": null,
          "name": null
      }
  },
  {
      "label": "∞ min",
      "id": "148",
      "type": 3,
      "price": "9,95 €",
      "provider": {
          "id": "163",
          "name": "Aire"
      }
  },
  {
      "label": "∞ min",
      "id": "14056",
      "type": 3,
      "price": "9,95 €",
      "provider": {
          "id": "164",
          "name": "Lemon"
      }
  },
  {
      "label": "4GB + 400 min Inter Zona EU",
      "id": "14057",
      "type": 3,
      "price": "11,95 €",
      "provider": {
          "id": "163",
          "name": "Aire"
      }
  },
  {
      "label": "10GB + llam ilim",
      "id": "11731",
      "type": 3,
      "price": "11,95 €",
      "provider": {
          "id": "164",
          "name": "Lemon"
      }
  },
  {
      "label": "∞ min + 30GB",
      "id": "12788",
      "type": 3,
      "price": "11,95 €",
      "provider": {
          "id": "164",
          "name": "Lemon"
      }
  },
  {
      "label": "15GB + llam ilim",
      "id": "11733",
      "type": 3,
      "price": "12,95 €",
      "provider": {
          "id": "163",
          "name": "Aire"
      }
  },
  {
      "label": "∞ min + 54GB",
      "id": "12787",
      "type": 3,
      "price": "15,95 €",
      "provider": {
          "id": "164",
          "name": "Lemon"
      }
  },
  {
      "label": "16GB + llam ilim",
      "id": "12789",
      "type": 3,
      "price": "15,95 €",
      "provider": {
          "id": "163",
          "name": "Aire"
      }
  },
  {
      "label": "21GB + llam ilim",
      "id": "12782",
      "type": 3,
      "price": "16,95 €",
      "provider": {
          "id": "163",
          "name": "Aire"
      }
  },
  {
      "label": "∞ min + 90GB",
      "id": "12786",
      "type": 3,
      "price": "19,95 €",
      "provider": {
          "id": "164",
          "name": "Lemon"
      }
  },
  {
      "label": "25GB + llam ilim",
      "id": "12790",
      "type": 3,
      "price": "19,95 €",
      "provider": {
          "id": "163",
          "name": "Aire"
      }
  },
  {
      "label": "30GB + llam ilim",
      "id": "12791",
      "type": 3,
      "price": "20,95 €",
      "provider": {
          "id": "163",
          "name": "Aire"
      }
  },
  {
      "label": "∞ min + 120GB",
      "id": "12785",
      "type": 3,
      "price": "21,95 €",
      "provider": {
          "id": "164",
          "name": "Lemon"
      }
  },
  {
      "label": "∞ min + 75GB",
      "id": "7056",
      "type": 3,
      "price": "24,95 €",
      "provider": {
          "id": "164",
          "name": "Lemon"
      }
  },
  {
      "label": "∞ min + 150GB",
      "id": "12784",
      "type": 3,
      "price": "24,95 €",
      "provider": {
          "id": "164",
          "name": "Lemon"
      }
  },
  {
      "label": "Máxima velocidad fin de semana",
      "id": "2202",
      "type": 2,
      "price": "9,95 €",
      "subtype": 21
  },
  {
      "label": "▼15Mb ▲6Mb",
      "id": "716",
      "type": 2,
      "price": "20,95 €",
      "subtype": 21
  },
  {
      "label": "▼20Mb ▲8Mb",
      "id": "483",
      "type": 2,
      "price": "26,95 €",
      "subtype": 21
  },
  {
      "label": "▼30Mb ▲12Mb",
      "id": "713",
      "type": 2,
      "price": "29,95 €",
      "subtype": 21
  },
  {
      "label": "50Mb/5Mb",
      "id": "6144",
      "type": 2,
      "price": "29,95 €",
      "subtype": 22
  },
  {
      "label": "100Mb/10Mb",
      "id": "11727",
      "type": 2,
      "price": "29,95 €",
      "subtype": 22
  },
  {
      "label": "50Mb simétricos",
      "id": "6145",
      "type": 2,
      "price": "34,95 €",
      "subtype": 22
  },
  {
      "label": "100Mb simétricos",
      "id": "11732",
      "type": 2,
      "price": "34,95 €",
      "subtype": 22
  },
  {
      "label": "▼50Mb ▲20Mb",
      "id": "580",
      "type": 2,
      "price": "39,95 €",
      "subtype": 21
  },
  {
      "label": "300Mb/10Mb",
      "id": "7634",
      "type": 2,
      "price": "39,95 €",
      "subtype": 22
  },
  {
      "label": "600Mb/10Mb",
      "id": "12793",
      "type": 2,
      "price": "39,95 €",
      "subtype": 22
  },
  {
      "label": "300Mb simétricos",
      "id": "7635",
      "type": 2,
      "price": "44,95 €",
      "subtype": 22
  },
  {
      "label": "600Mb Simétrica",
      "id": "14053",
      "type": 2,
      "price": "44,95 €",
      "subtype": 22
  },
  {
      "label": "▼70Mb ▲30Mb",
      "id": "5316",
      "type": 2,
      "price": "49,95 €",
      "subtype": 21
  },
  {
      "label": "1 Giga Simétrico",
      "id": "14054",
      "type": 2,
      "price": "59,95 €",
      "subtype": 22
  },
  {
      "label": "naduPack MINI (30Mb + 30GB)",
      "id": "19284",
      "type": 1,
      "price": "29,95 €",
      "services": [
          {
              "id": "36",
              "name": "Internet"
          },
          {
              "id": "49",
              "name": "Móvil"
          }
      ]
  },
  {
      "label": "naduPack SUPREME (50Mb + 150GB)",
      "id": "19285",
      "type": 1,
      "price": "49,95 €",
      "services": [
          {
              "id": "36",
              "name": "Internet"
          },
          {
              "id": "49",
              "name": "Móvil"
          }
      ]
  },
  {
      "label": "Conexión simétrica",
      "id": "19287",
      "type": 4,
      "price": "5,00 €"
  },
  {
      "label": "IP fija",
      "id": "19286",
      "type": 4,
      "price": "8,00 €"
  }
];
const fiscalIdTypeOptions = [
  { value: "93", label: "DNI" },
  { value: "94", label: "NIE" },
  { value: "96", label: "Pasaporte" } /*,
  { value: "95", label: "NIF" }
  ,
  { value: "three", label: "Baja" },
  { value: "four", label: "Suspensión por impago" },
  { value: "five", label: "Cambio de nombre" },
  { value: "six", label: "Cambio de tarifa" }*/
];
const customerTypeOptions = [
  { value: "89", label: "Particular" },
  { value: "91", label: "Autónomo" },
  { value: "90", label: "Empresa" },
  { value: "92", label: "Extranjero" }
  /*,
  { value: "three", label: "Baja" },
  { value: "four", label: "Suspensión por impago" },
  { value: "five", label: "Cambio de nombre" },
  { value: "six", label: "Cambio de tarifa" }*/
];
var checkIBAN = (function() {
  // use an IIFE
  // A "constant" lookup table of IBAN lengths per country
  // (the funky formatting is just to make it fit better in the answer here on CR)
  var CODE_LENGTHS = {
    AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
    CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
    FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
    HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
    LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
    MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
    RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26
  };

  // piece-wise mod97 using 9 digit "chunks", as per Wikipedia's example:
  // http://en.wikipedia.org/wiki/International_Bank_Account_Number#Modulo_operation_on_IBAN
  function mod97(string) {
    var checksum = string.slice(0, 2),
        fragment;

    for(var offset = 2 ; offset < string.length ; offset += 7) {
      fragment = String(checksum) + string.substring(offset, offset + 7);
      checksum = parseInt(fragment, 10) % 97;
    }

    return checksum;
  }

  // return a function that does the actual work
  return function (input) {
    var iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
        code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/),           // match and capture (1) the country code, (2) the check digits, and (3) the rest
        digits;

    // check syntax and length
    if(!code || iban.length !== CODE_LENGTHS[code[1]]) {
      return false;
    }

    // rearrange country code and check digits, and convert chars to ints
    digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
      return letter.charCodeAt(0) - 55;
    });

    // final check
    return mod97(digits) === 1;
  };
}());

class ViewContract extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      areItemsLoading: false,
      contractProducts: null /*this.props.state.contract.products*/,
      templateName: null,
      fieldStates: [],
      productsLoaded: false,
      signature: null /*this.props.state.contract.signature*/,
      currentStep: PRODUCTOS,
      customerData: null /*this.props.state.contract.customer*/,
      identificationDocuments: /*this.props.state.contract.documents ||*/ {},
      contractLoaded: false,
      isSigningContract: false
    };
    this.buildProductsCards = this.buildProductsCards.bind(this);
    this.buildContractProducts = this.buildContractProducts.bind(this);
    this.addProductToContract = this.addProductToContract.bind(this);
    this.cleanContractProducts = this.cleanContractProducts.bind(this);
    this.validateField = this.validateField.bind(this);
    this.validateSendContract = this.validateSendContract.bind(this);
    this.sendContract = this.sendContract.bind(this);
    this.saveTemplate = this.saveTemplate.bind(this);
    this.createContract = this.createContract.bind(this);
    this.saveSignature = this.saveSignature.bind(this);
    this.buildFooter = this.buildFooter.bind(this);
    this.nextClick = this.nextClick.bind(this);
    this.previousClick = this.previousClick.bind(this);
    this.buildContent = this.buildContent.bind(this);
    this.buildCustomerType = this.buildCustomerType.bind(this);
    this.buildCustomerBasicData = this.buildCustomerBasicData.bind(this);
    this.buildCustomerAddress = this.buildCustomerAddress.bind(this);
    this.buildCustomerSignature = this.buildCustomerSignature.bind(this);
    this.checkCustomerType = this.checkCustomerType.bind(this);
    this.checkBasicData = this.checkBasicData.bind(this);
    this.checkBasicDataNotCompany = this.checkBasicDataNotCompany.bind(this);
    this.checkAddress = this.checkAddress.bind(this);
    this.clearSignature = this.clearSignature.bind(this);
    this.buildExistingCustomer = this.buildExistingCustomer.bind(this);
    this.createCustomer = this.createCustomer.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
    this.goBack = this.goBack.bind(this);
    /* ////console.log(props); */
  }
  formatIBAN(iban) {
    try {
      let formattedIban = (iban.replace(/ /g, "").match(/[\s\S]{1,4}/g) || []).join(" ");
      return formattedIban;
    } catch (e) {
      return "";
    }
  }
  validateIBAN(iban) {
    return checkIBAN(iban) && iban.replace(/ /g, "").length === 24;
  }
  validateNombre(nombre) {
    let result = false;
    if (nombre && nombre.length > 1) result = true;
    return result;
  }
  validateField(field, value) {
    let fieldStates = this.state.fieldStates;
    let localFieldName = field;
    if (field.includes("firstname")) localFieldName = "nombre";
    if (field.includes("lastname")) localFieldName = "primer_apellido";
    if (field.includes("mobile")) localFieldName = "movil";
    if (field.includes("dni")) localFieldName = "nif";
    if (field.includes("street")) localFieldName = "direccion";
    if (field.includes("locality")) localFieldName = "localidad";
    if (field.includes("postal")) localFieldName = "codigo_postal";
    if (field.includes("comunity")) localFieldName = "direccion";
    if (field.includes("province")) localFieldName = "direccion";
    switch (localFieldName) {
      case "phoneNumber":
        if (this.validatePhoneNumber(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "movil":
        if (this.validatePhoneNumber(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "ICC":
        if (this.validateICC(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "iban":
        if (this.validateIBAN(value)) {
          fieldStates[field] = "has-success";
          // if (this.isNewIBAN(value)) {
          //   // this.props.setCustomerIBAN(this.state.customer.id, value);
          //   this.setState({ latestValidatedIBAN: value.replace(/ /g, "") });
          // }
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "newPassword":
        if (this.validateNewPassword(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "nombre":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "primer_apellido":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "segundo_apellido":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "email":
        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRex.test(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "nif":
        var regPassport = /^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/;
        var validPassport = regPassport.test(value);
        if (validateSpanishId(value) || validPassport) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "direccion":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "localidad":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "codigo_postal":
        if (value && value > 0 && value.length === 5) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      default:
    }
    this.setState({ fieldStates: fieldStates });
  }
  componentDidMount() {
    // if(!this.state.areItemsLoading && !(this.props.match.params.orderNumber in this.props.mainState.ordersArticles)) {
    //   this.props.getOrdersArticles(this.props.match.params.orderNumber, null, null, null, true);
    //   this.setState({ areItemsLoading: true });
    // }
    if (!this.state.productsLoaded) {
      // this.props.getContractProducts();
      this.setState({ productsLoaded: true });
    }
    // console.log("#### TEST CONTRACT ####");
    // console.log(this.props.match.params.contract_id);
    if (this.props.match.params && this.props.match.params.contract_id) {
      this.props.getContract(this.props.match.params.contract_id);
    }
  }
  componentWillUnmount() {
    this.props.cleanContract();
  }
  componentDidUpdate(prevProps, prevState) {
    // console.log("UPDATE");
    // console.log(this.state);
    let contract = this.state.contract;
    let alreadySigned = contract ? (parseInt(contract.status) === 230 || parseInt(contract.status) === 231) : false;
    if (this.props.mainState.closeContract) this.goBack();
    if (this.state.currentStep !== prevState.currentStep) {
      document.querySelector('.main-panel').scrollTop = 0;
    }
    if ((alreadySigned || (this.state.currentStep === FIRMA && prevState.currentStep !== FIRMA)) && this.state.signature && this.signature) {
      // console.log("Rellenando firma después de actualizar");
      this.signature.clear();
      this.signature.fromDataURL(this.state.signature);
    }
    if (this.state.isSigningContract) {
      document.querySelector('.main-panel').scrollTop = 0;
    }
    let contractLoaded = this.props.mainState.contract;
    // console.log("####### CONTRACT CONTENT #######");
    // console.log(contractLoaded);
    if (!this.state.contractLoaded && 
        this.props.mainState.contract && 
        parseInt(this.props.mainState.contract.id) === parseInt(this.props.match.params.contract_id)) {
          // this.state = {
          //   areItemsLoading: false,
          //   contractProducts: null /*this.props.state.contract.products*/,
          //   templateName: null,
          //   fieldStates: [],
          //   productsLoaded: false,
          //   signature: null /*this.props.state.contract.signature*/,
          //   currentStep: PRODUCTOS,
          //   customerData: null /*this.props.state.contract.customer*/,
          //   identificationDocuments: /*this.props.state.contract.documents ||*/ {},
          //   contractLoaded: false
          // };
          let contractLoaded = this.props.mainState.contract;
          // console.log("####### CONTRACT CONTENT #######");
          // console.log(contractLoaded);
          this.setState({
              contractProducts: contractLoaded.products,
              signature: contractLoaded.signature,
              customerData: contractLoaded.customerData,
              identificationDocuments: contractLoaded.documents,
              contractLoaded: true,
              contract: contractLoaded,
              existingCustomer: contractLoaded.existing_customer
          });
          if (contractLoaded.existing_customer) {
            this.props.searchBulkCustomer([contractLoaded.existing_customer]);
          }
        }
  }
  saveSignature() {
    this.setState({ signature: this.signature.toDataURL() });
  }
  validatePhoneNumber(phoneNumber) {
    let result = false;
    if (this.validateNumber(phoneNumber)) {
      if (phoneNumber.startsWith("6") || phoneNumber.startsWith("7") || phoneNumber.startsWith("8") || phoneNumber.startsWith("9")) {
        if (phoneNumber.length === 9) {
          result = true;
        }
      }
    }
    return result;
  }
  validateNumber(e) {
    var numberRex = new RegExp("^[0-9]+$");
    if (numberRex.test(e)) {
      return true;
    } else {
      return false;
    }
  }
  validateSendContract() {
    let result = true;
    this.state.contractProducts.map(product => {
      product.extraFields.map(field => {
        if (this.state.fieldStates[field.id] === "has-danger") result = false;
        if (!this.state.fieldStates[field.id]) result = false;
      });
    });
    if (this.state.fieldStates['clientMobile'] === "has-danger") result = false;
    if (!this.state.fieldStates['clientMobile']) result = false;
    if (this.state.fieldStates['contractIdentifier'] === "has-danger") result = false;
    if (!this.state.fieldStates['contractIdentifier']) result = false;
    return result;
  }
  validateSaveTemplate() {
    let result = true;
    if (this.state.fieldStates['nombrePlantilla'] === "has-danger") result = false;
    if (!this.state.fieldStates['nombrePlantilla']) result = false;
    return result;
  }
  cleanContractProducts() {
    this.setState({ contractProducts: null });
  }
  removeProductToContract(id) {
    let auxContractProducts = this.state.contractProducts;
    auxContractProducts = auxContractProducts.map((product, key) => {
      if (key !== id) return product;
      return null;
    });
    auxContractProducts = auxContractProducts.filter(function(el) {
      return el != null;
    });
    this.setState({
      contractProducts: auxContractProducts
    });
  }
  addProductToContract(product) {
    // console.log("###### addProduct ######");
    // console.log(this.state.contractProducts);
    product.id = Date.now() + "product" + product.id + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    product.extraFields = [];

    switch (product.type) {
      case INTERNET:
        product.extraFields.push({
          id: product.id + "field1" + "-text",
          label: "Dirección",
          placeholder: "Calle Melan...",
          type: "text",
          value: ""
        });
        break;
      case MOVIL:
        product.extraFields.push({
          id: product.id + "field1" + "-mobile",
          label: "Móvil",
          placeholder: "612345678",
          type: "number",
          value: ""
        });
        break;
      case PACK:
        product.extraFields.push({
          id: product.id + "field1" + "-text",
          label: "Dirección",
          placeholder: "Calle Melan...",
          type: "text",
          value: ""
        });
        product.extraFields.push({
          id: product.id + "field2" + "-mobile",
          label: "Móvil",
          placeholder: "612345678",
          type: "number",
          value: ""
        });
        break;
      default:
        break;
    }

    let auxContractProducts = this.state.contractProducts;
    if (!auxContractProducts) auxContractProducts = [];
    auxContractProducts.push(JSON.parse(JSON.stringify(product)));
    // console.log("###### addProduct - auxContractProducts ######");
    // console.log(auxContractProducts);
    this.setState({
      contractProducts: auxContractProducts
    });
  }
  buildContractProducts() {
    // console.log("######### PRODUCTOS CONTRATO ########");
    // console.log(JSON.stringify(this.state.contractProducts));
    let contractContent = null;
    let classifiedContractContent = null;
    if (this.state.contractProducts && this.state.contractProducts.length > 0) {
      contractContent = [];
      classifiedContractContent = [];
      let total = 0;
      let cardsProps = {
        xs: 12,
        lg: 6
      };
      let totalOnePayment = 0;

      this.state.contractProducts.map((product, key) => {
        let productColor = "default";
        let productType = "General";
        let subTotal = product.price.replace(" €", "").replace(",", ".");
        let textColor = ""
        let currentTypeName = "";
        if ((product.type === OTROS && product.onePayment) || (product.label.toLowerCase().includes("instalaci"))) {
          subTotal = parseFloat(subTotal);
          totalOnePayment += subTotal;
        } else {
            subTotal = parseFloat(subTotal);
            total += subTotal;
        }
        switch (product.type) {
          case INTERNET:
            productType = "Fibra";
            productColor = "warning";
            currentTypeName = "Internet";
            if (product.subtype === WIFI) {
              productColor = "primary";
              productType = "WiFi";
            }
            break;
          case PACK:
            productType = "Pack";
            productColor = "info";
            textColor = "text-white";
            currentTypeName = "Packs";
            break;
          case OTROS:
            productType = "Otros";
            productColor = "danger";
            currentTypeName = "Otros";
            break;
          case MOVIL:
            productType = "Móvil";
            productColor = "default";
            currentTypeName = "Móvil";
            if (product.provider) {
              if (product.provider.id === "163") productColor = "blue";
              if (product.provider.id === "164") productColor = "orange";
            }
            break;
          default:
            break;
        }
        let productFields = [];
        // console.log("##### current product #####");
        // console.log(this.state.contractProducts[key]);
        productFields = product.extraFields.map((field, fieldKey) => {
          // console.log("##### current product - field #####");
          // console.log(this.state.contractProducts[key].extraFields[fieldKey]);
          return (
            <FormGroup
              key={field.id}
              className={this.state.fieldStates[field.id]}
            >
              <Input
                disabled
                className="text-center"
                type={field.type}
                placeholder={field.placeholder}
                style={{ backgroundColor: "white" }}
                value={this.state.contractProducts[key].extraFields[fieldKey].value || ""}
                onChange={event => {
                  let newValue = event.target.value;
                  if (field.type === "number") newValue = newValue.replace(/\s+/g, '');
                  let newContractProducts = this.state.contractProducts;
                  newContractProducts[key].extraFields[fieldKey].value = newValue;

                  this.setState({ contractProducts: newContractProducts });
                  // this.validateField("phoneNumber", event.target.value.replace(/\s+/g, ''));
                  this.validateField(field.id, newValue);
                }}
              />
            </FormGroup>
          );
        });
        let currentClassifiedContractContent = [];
        if (product.type in classifiedContractContent) currentClassifiedContractContent = classifiedContractContent[product.type].products;
        currentClassifiedContractContent.push(
          <Col key={key} {...cardsProps}>
            <Card
              color={productColor}
              className={"text-center " + textColor}
              onContextMenu={e => {
                e.preventDefault();
                this.removeProductToContract(key);
              }}
            >
              <CardHeader>
                <CardTitle tag="h5">{product.label}</CardTitle>
              </CardHeader>
              <CardBody>
                {product.permanence && <Row><Col className="text-center"><p>{product.permanence.label}</p></Col></Row>}
                {productFields}
              </CardBody>
              <CardFooter>
                <Row>
                  <Col xs={6} className="text-left">{productType}</Col>
                  <Col xs={6} className="text-right">{product.price}</Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        );
        classifiedContractContent[product.type] = {
          name: currentTypeName,
          products: currentClassifiedContractContent
        };
      });
      contractContent = [];
      classifiedContractContent.map((currentType, key) => {
        let temporaryProductsToWrap = [];
        temporaryProductsToWrap.push(
          <Col key={currentType.name} xs={12}>
            <h5>{currentType.name}</h5>
          </Col>
        );
        currentType.products.map(currentProduct => {
          temporaryProductsToWrap.push(currentProduct);
        });
        contractContent.push(<Row key={key + currentType.name}>{temporaryProductsToWrap}</Row>);
      });

      let multiple_totals = total > 0 && totalOnePayment > 0;
      let contractHeader =
        <Col xs={12} md={multiple_totals ? 6 : 12}>
          <Card className="text-center" color="info">
            <CardHeader>
              <CardTitle tag="h4" className="text-center">Total mensual</CardTitle>
            </CardHeader>
            <CardBody className="text-center txt-white h3 h-nomargin">
              {(total.toFixed(2) + " €").replace(".", "'")}
            </CardBody>
            <CardFooter></CardFooter>
          </Card>
        </Col>;

      let contractHeaderOnePayment =
        <Col xs={12} md={multiple_totals ? 6 : 12}>
          <Card className="text-center" color="primary">
            <CardHeader>
              <CardTitle tag="h4" className="text-center">Total pago único</CardTitle>
            </CardHeader>
            <CardBody className="text-center txt-white h3 h-nomargin">
              {(totalOnePayment.toFixed(2) + " €").replace(".", "'")}
            </CardBody>
            <CardFooter></CardFooter>
          </Card>
        </Col>;
      contractHeader =
        <Row>
          {total > 0 && contractHeader}
          {totalOnePayment > 0 && contractHeaderOnePayment}
        </Row>;

      contractContent = 
        <div key="contract_products">
          {contractHeader}
          <Card>
            <CardHeader>
              <CardTitle tag="h4" className="text-center">Servicios del contrato</CardTitle>
            </CardHeader>
            <CardBody>
              {contractContent}
            </CardBody>
          </Card>
        </div>;
    } else {
      contractContent = 
        <Card>
          <CardHeader>
            <CardTitle tag="h4" className="text-center">Servicios del contrato</CardTitle>
          </CardHeader>
          <CardBody>
            <div className="text-center">
              <i className="now-ui-icons shopping_box" /> ¡Añade servicios pulsando sobre ellos!
            </div>
            <br />
          </CardBody>
        </Card>;
    }
    return contractContent;
  }
  buildProductsCards(internetProducts, packProducts, othersProducts, mobileProducts) {
    let result = null;
    let resultFibra = [];
    let resultWifi = [];
    let resultPacks = [];
    let resultOthers = [];
    let resultMobiles = [];
    let fibraNumber = 0;
    let wifiNumber = 0;
    let cardsProps = {
      xs: 12 /*,
      xl: 6*/
    }
    if (internetProducts) {
      internetProducts.map(product => {
        let currentType = resultFibra;
        if (product.subtype === FIBRA) {
          fibraNumber += 1;
        } else {
          wifiNumber += 1;
          currentType = resultWifi;
        }
        currentType.push(
          <Col key={"internetProducts" + "product" + product.id} {...cardsProps}>
            <Card
              key={product.id}
              onClick={() => this.addProductToContract(product)}
              color={product.subtype === FIBRA ? "warning" : "primary"}
              className="text-center"
            >
              <CardHeader>
                <CardTitle tag="h5">{product.label}</CardTitle>
              </CardHeader>
              <CardFooter>
                <Row>
                  <Col xs={6} className="text-left">{product.subtype === FIBRA ? "Fibra" : "WiFi"}</Col>
                  <Col xs={6} className="text-right">{product.price}</Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        );
        if (product.subtype === FIBRA) {
          resultFibra = currentType;
        } else {
          resultWifi = currentType;
        }
      });
    }
    if (packProducts) {
      packProducts.map(product => {
        resultPacks.push(
          <Col key={"packProducts" + "product" + product.id} {...cardsProps}>
            <Card
              key={product.id}
              onClick={() => this.addProductToContract(product)}
              color="info"
              className="text-center text-white"
            >
              <CardHeader>
                <CardTitle tag="h5">{product.label}</CardTitle>
              </CardHeader>
              <CardFooter>
                <Row>
                  <Col xs={6} className="text-left">Pack</Col>
                  <Col xs={6} className="text-right">{product.price}</Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        );
      });
    }
    if (othersProducts) {
      othersProducts.map(product => {
        resultOthers.push(
          <Col key={"othersProducts" + "product" + product.id} {...cardsProps}>
            <Card
              key={product.id}
              onClick={() => this.addProductToContract(product)}
              color="danger"
              className="text-center"
            >
              <CardHeader>
                <CardTitle tag="h5">{product.label}</CardTitle>
              </CardHeader>
              <CardFooter>
                <Row>
                  <Col xs={6} className="text-left">Otros</Col>
                  <Col xs={6} className="text-right">{product.price}</Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        );
      });
    }
    if (mobileProducts) {
      mobileProducts.map(product => {
        let productColor = "default";
        if (product.provider) {
          if (product.provider.id === "163") productColor = "blue";
          if (product.provider.id === "164") productColor = "orange";
        }
        resultMobiles.push(
          <Col key={"mobilesProducts" + "product" + product.id} {...cardsProps}>
            <Card
              key={product.id}
              onClick={() => this.addProductToContract(product)}
              color={productColor}
              className="text-center"
            >
              <CardHeader>
                <CardTitle tag="h5">{product.label}</CardTitle>
              </CardHeader>
              <CardFooter>
                <Row>
                  <Col xs={6} className="text-left">Móvil</Col>
                  <Col xs={6} className="text-right">{product.price}</Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        );
      });
    }

    result = 
      <TabContent activeTab={this.state.vTabs}>
        <TabPane tabId="vt1">
          <Nav pills className="nav-pills-primary">
            <NavItem>
              <NavLink
                className={
                  this.state.internetTabs === "fibra" ? "active" : ""
                }
                onClick={() => this.setState({ internetTabs: "fibra" })}
              >
                {"Fibra (" + fibraNumber + ")"}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={
                  this.state.internetTabs === "wifi" ? "active" : ""
                }
                onClick={() => this.setState({ internetTabs: "wifi" })}
              >
              {"WiFi (" + wifiNumber + ")"}
              </NavLink>
            </NavItem>
          </Nav>
          <br />
          <TabContent activeTab={this.state.internetTabs}>
            <TabPane tabId="fibra">
              <Row>
                {resultFibra}
              </Row>
            </TabPane>
            <TabPane tabId="wifi">
              <Row>
                {resultWifi}
              </Row>
            </TabPane>
          </TabContent>
        </TabPane>
        <TabPane tabId="vt2">
          <Row>
            {resultPacks}
          </Row>
        </TabPane>
        <TabPane tabId="vt4">
          <Row>
            {resultMobiles}
          </Row>
        </TabPane>
        <TabPane tabId="vt3">
          <Row>
            {resultOthers}
          </Row>
        </TabPane>
      </TabContent>;
    
    return result;
  }
  sendContract() {
    if (this.validateSendContract()) {
      let contract = {
        name: this.state.contractIdentifier,
        products: JSON.stringify(this.state.contractProducts),
        mobile: this.state.clientMobile,
        type: CONTRATO
      };
      this.createContract(contract);
    }
  }
  saveTemplate() {
    if (this.validateSaveTemplate()) {
      let contract = {
        name: this.state.templateName,
        products: JSON.stringify(this.state.contractProducts),
        type: PLANTILLA
      };
      this.createContract(contract);
    }
  }
  createContract(contract) {
    this.props.createContract(contract);
  }
  checkCustomerType() {
    let result = true;
    if (this.state.existingCustomer) return true;
    if (!this.state.customerData.customerType) {
      result = false;
    }

    return result;
  }
  checkBasicData() {
    if (this.state.existingCustomer) return true;
    if (this.state.customerData.customerType.value === "90") {
      return this.checkBasicDataCompany();
    } else {
      return this.checkBasicDataNotCompany();
    }
  }
  checkBasicDataNotCompany() {
    let result = true;
    if (this.state.existingCustomer) return true;
    if (!this.state.customerData.fiscalIdType) {
      result = false;
      let options = {
        place: "tr",
        message: "Es necesario especificar el tipo de documento identificativo",
        type: "primary",
        icon: "now-ui-icons ui-1_check ",
        autoDismiss: 3
      };
      this.props.userData.showNotification(options);
    }
    if (!this.state.customerData.dni || (this.state.fieldStates['dni'] && this.state.fieldStates['dni'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El " + (this.state.customerData.fiscalIdType ? this.state.customerData.fiscalIdType.label : "documento identificativo") + " es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.firstname || (this.state.fieldStates['firstname'] && this.state.fieldStates['firstname'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El nombre es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.lastname || (this.state.fieldStates['lastname'] && this.state.fieldStates['lastname'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El primer apellido es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.lastname2 || (this.state.fieldStates['lastname2'] && this.state.fieldStates['lastname2'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El segundo apellido es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.mobile || (this.state.fieldStates['mobile'] && this.state.fieldStates['mobile'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El móvil es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.email || (this.state.fieldStates['email'] && this.state.fieldStates['email'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El email es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.iban || (this.state.fieldStates['iban'] && this.state.fieldStates['iban'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El IBAN es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }

    return result;
  }
  checkBasicDataCompany() {
    let result = true;
    if (this.state.existingCustomer) return true;
    if (!this.state.customerData.dni || (this.state.fieldStates['dni'] && this.state.fieldStates['dni'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El " + (this.state.customerData.fiscalIdType ? this.state.customerData.fiscalIdType.label : "documento identificativo") + " es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.firstname || (this.state.fieldStates['firstname'] && this.state.fieldStates['firstname'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El nombre es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.mobile || (this.state.fieldStates['mobile'] && this.state.fieldStates['mobile'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El móvil es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.email || (this.state.fieldStates['email'] && this.state.fieldStates['email'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El email es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.iban || (this.state.fieldStates['iban'] && this.state.fieldStates['iban'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El IBAN es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.firstnameManager || (this.state.fieldStates['firstnameManager'] && this.state.fieldStates['firstnameManager'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El nombre del gerente es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.lastnameManager || (this.state.fieldStates['lastnameManager'] && this.state.fieldStates['lastnameManager'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El primer apellido del gerente es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.lastname2Manager || (this.state.fieldStates['lastname2Manager'] && this.state.fieldStates['lastname2Manager'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El segundo apellido del gerente es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.dniManager || (this.state.fieldStates['dniManager'] && this.state.fieldStates['dniManager'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El DNI del gerente es incorrecto",
        type: "danger",
        icon: "now-ui-icons users_single-02",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }

    return result;
  }
  checkAddress() {
    let result = true;
    if (this.state.existingCustomer) return true;
    if (!this.state.customerData.street || (this.state.fieldStates['street'] && this.state.fieldStates['street'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "La calle es incorrecta",
        type: "danger",
        icon: "now-ui-icons location_map-big",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.locality || (this.state.fieldStates['locality'] && this.state.fieldStates['locality'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "La localidad es incorrecta",
        type: "danger",
        icon: "now-ui-icons location_map-big",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.postalCode || (this.state.fieldStates['postalCode'] && this.state.fieldStates['postalCode'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "El código postal es incorrecto",
        type: "danger",
        icon: "now-ui-icons location_map-big",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.province || (this.state.fieldStates['province'] && this.state.fieldStates['province'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "La provincia es incorrecta",
        type: "danger",
        icon: "now-ui-icons location_map-big",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.customerData.comunity || (this.state.fieldStates['comunity'] && this.state.fieldStates['comunity'].includes("danger"))) {
      result = false;
      let options = {
        place: "tr",
        message: "La comunidad es incorrecta",
        type: "danger",
        icon: "now-ui-icons location_map-big",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }

    return result;
  }
  checkSignature() {
    let result = true;
    if (!this.signature || this.signature.isEmpty()) {
      result = false;
      let options = {
        place: "tr",
        message: "Es necesario rellenar la firma",
        type: "danger",
        icon: "now-ui-icons design-2_ruler-pencil",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    }
    if (!this.state.identificationDocuments) {
      result = false;
      let options = {
        place: "tr",
        message: "Son necesarias las fotos del documento de identidad",
        type: "danger",
        icon: "now-ui-icons design_image",
        autoDismiss: 3
      };
      this.props.showNotification(options);
    } else {
      if (!this.state.identificationDocuments.front) {
        result = false;
        let options = {
          place: "tr",
          message: "Es necesaria la foto frontal del documento de identidad",
          type: "danger",
          icon: "now-ui-icons design_image",
          autoDismiss: 3
        };
        this.props.showNotification(options);
      }
      if (!this.state.identificationDocuments.back) {
        result = false;
        let options = {
          place: "tr",
          message: "Es necesaria la foto trasera del documento de identidad",
          type: "danger",
          icon: "now-ui-icons design_image",
          autoDismiss: 3
        };
        this.props.showNotification(options);
      }
    }
    return result;
  }
  checkContract() {
    let customerTypeReady = this.checkCustomerType();
    let basicDataReady = this.checkBasicData();
    let addressReady = this.checkAddress();
    let signatureReady = this.checkSignature();
    console.log("Check contract (customerTypeReady)", customerTypeReady);
    console.log("Check contract (basicDataReady)", basicDataReady);
    console.log("Check contract (addressReady)", addressReady);
    console.log("Check contract (signatureReady)", signatureReady);
    return (
      customerTypeReady &&
      basicDataReady &&
      addressReady &&
      signatureReady
    );
  }
  nextClick() {
    switch (this.state.currentStep) {
      case PRODUCTOS:
        if (this.state.existingCustomer) {
          this.setState({ currentStep: FIRMA });
        } else {
          this.setState({ currentStep: TIPO_CLIENTE });
        }
        break;
      case TIPO_CLIENTE:
        if (this.checkCustomerType()) {
          let aux = this.state;
          if (this.state.customerData.customerType.value === "90") {
            aux.customerData.fiscalIdType = { value: "95", label: "NIF" };
          } else {
            if (this.state.customerData.fiscalIdType && this.state.customerData.fiscalIdType.value === "95")
              aux.customerData.fiscalIdType = undefined;
          }
          this.setState({ currentStep: DATOS_BASICOS });
        } else {
          var options = {
            place: "tr",
            message: "Es necesario especificar el tipo de cliente",
            type: "danger",
            icon: "now-ui-icons users_single-02",
            autoDismiss: 3
          };
          this.props.showNotification(options);
        }
        break;
      case DATOS_BASICOS:
        if (this.checkBasicData()) {
          this.setState({ currentStep: DIRECCION });
        }
        break;
      case DIRECCION:
        if (this.checkAddress()) {
          this.setState({ currentStep: FIRMA });
        }
        break;
      default:
    }
  }
  previousClick() {
    switch (this.state.currentStep) {
      case FIRMA:
        if (this.state.existingCustomer) {
          this.setState({ currentStep: PRODUCTOS });
        } else {
          this.setState({ currentStep: DIRECCION });
        }
        break;
      case DIRECCION:
        this.setState({ currentStep: DATOS_BASICOS });
        break;
      case DATOS_BASICOS:
        this.setState({ currentStep: TIPO_CLIENTE });
        break;
      case TIPO_CLIENTE:
        this.setState({ currentStep: PRODUCTOS });
        break;
      default:
    }
  }
  exitClick(alreadySigned, saveChanges) {
    if (!alreadySigned) {
      let contract = null;
      if (saveChanges) {
        let isData = Object.keys(this.state.customerData).length > 0;
        contract = {
          customer: isData ? JSON.stringify(this.state.customerData) : "{}",
          documents: this.state.identificationDocuments
        };
        // if (saveContract)
        //   contract = {
        //     customer: JSON.stringify(this.state.customerData),
        //     documents: this.state.identificationDocuments
        //   };
      }
      this.props.closeContract(contract);
      this.setState({
          goToContracts: true
      });
    } else {      
      this.goBack();
    }
  }
  signContract() {
    if (this.checkContract()) {
      let contract = null;
      contract = {
        customer: JSON.stringify(this.state.customerData),
        documents: this.state.identificationDocuments,
        signature: this.signature.toDataURL()
      };
      this.props.closeContract(contract);
    }
  }
  buildFooter(alreadySigned) {
    let leftButton = null;
    let rightButton = null;
    let bottomButton = null;
    let nextButton = (
      <Button
        color="primary"
        size="lg"
        onClick={() => {
          this.nextClick();
        }}
      >
        Siguiente
      </Button>
    );
    let startButton = (
      <Button
        color="primary"
        size="lg"
        onClick={() => {
          this.nextClick();
        }}
      >
        Rellenar
      </Button>
    );
    if (alreadySigned) {
      startButton = null;
    }
    let previousButton = (
      <Button
        color="info"
        size="lg"
        onClick={() => {
          this.previousClick();
        }}
      >
        Anterior
      </Button>
    );
    let exitButton = (
      <Button
        color="danger"
        size="lg"
        onClick={() => {
          this.exitClick(alreadySigned, false);
        }}
      >
        Salir
      </Button>
    );
    let saveExitButton = (
      <Button
        color="default"
        size="lg"
        onClick={() => {
          this.exitClick(alreadySigned, true);
        }}
      >
        Guardar y salir
      </Button>
    );
    let sendButton = (
      <Button
        color="primary"
        size="lg"
        onClick={() => {
          this.signContract();
        }}
      >
        Enviar
      </Button>
    );
    let exitRow = (
      <Row>
        <Col xs={12}>
          <Card className="text-left">
            <CardBody>
              <Row around="xs" /*className="align-items-center"*/>
                <Col xs={6} md={6} className="text-left">
                  {exitButton}
                </Col>
                <Col xs={6} md={6} className="text-right">
                  {saveExitButton}
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
    switch (this.state.currentStep) {
      case PRODUCTOS:
        leftButton = exitButton;
        rightButton = startButton;
        exitRow = null;
        break;
      case TIPO_CLIENTE:
        leftButton = previousButton;
        rightButton = nextButton;
        break;
      case DATOS_BASICOS:
        leftButton = previousButton;
        rightButton = nextButton;
        break;
      case DIRECCION:
        leftButton = previousButton;
        rightButton = nextButton;
        break;
      case FIRMA:
        leftButton = previousButton;
        rightButton = sendButton;
        break;
      default:
    }
    let footer = (
      <div>
        <Row>
          <Col xs={12}>
            <Card className="text-center">
              <CardBody className="text-right">
                <Row around="xs" /*className="align-items-center"*/>
                  <Col xs={6} md={6} className="text-left">
                    {leftButton}
                  </Col>
                  <Col xs={6} md={6} className="text-right">
                    {rightButton}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {exitRow}
      </div>
    );

    return footer;
  }
  buildCustomerType() {
    try {
      let customerType = (
        <Card key="customer_type" className="text-center">
          <CardHeader>
            <CardTitle tag="h4" className="text-center">Tipo de cliente</CardTitle>
          </CardHeader>
          <CardBody className="text-right">
            <Row around="xs" className="align-items-center">
              <Col xs={12}>
                <FormGroup>
                  <Select
                    className="react-select primary text-center"
                    classNamePrefix="react-select"
                    placeholder="Selecciona un tipo"
                    name="tipo"
                    value={this.state.customerData.customerType || ""}
                    options={customerTypeOptions}
                    onChange={value => {
                      let aux = this.state.customerData;
                      aux.customerType = value;
                      this.setState({ customerData: aux });
                    }}
                  />
                  <br></br>
                </FormGroup>
              </Col>
            </Row>
          </CardBody>
        </Card>
      );
      return customerType;
    } catch (error) {
      return null;
    }
  }
  buildCustomerBasicData() {
    try {
      let fiscalIdTypeField = null;
      let managerFields = null;
      let notEnterpriseFields = null;
      // console.log(this.state);
      if (this.state.customerData.customerType.value !== "90") {
        fiscalIdTypeField = (
          <Col xs={12} sm="6">
            {/* Necesario que esté duplicado el FormGroup para que no coga el valor del select anterior (tipo de cliente) */}
            <FormGroup style={{display:"none"}}>
              <Select
                className="react-select primary text-center"
                classNamePrefix="react-select"
                placeholder="Tipo de documento"
                name="fiscalIdType"
                value={this.state.customerData.fiscalIdType || ""}
                options={fiscalIdTypeOptions}
                onChange={value => {
                  let aux = this.state.customerData;
                  aux.fiscalIdType = value;
                  this.setState({ customerData: aux });
                }}
              />
            </FormGroup>
            <FormGroup>
              <Select
                className="react-select primary text-center"
                classNamePrefix="react-select"
                placeholder="Tipo de documento"
                name="fiscalIdType"
                value={this.state.customerData.fiscalIdType || ""}
                options={fiscalIdTypeOptions}
                onChange={value => {
                  let aux = this.state.customerData;
                  aux.fiscalIdType = value;
                  this.setState({ customerData: aux });
                }}
              />
            </FormGroup>
          </Col>
        );
        notEnterpriseFields = [];
        notEnterpriseFields.push(
          <Col xs={12} sm="6" key="lastname">
            <InputGroup
              className={
                "form-control-lg " +
                (this.state.fieldStates["lastname"] || "") +
                (this.state.lastnameFocus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons text_caps-small" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.state.customerData.lastname || ""}
                type="text"
                placeholder="Primer apellido"
                name="lastname"
                onFocus={e => this.setState({ lastnameFocus: true })}
                onBlur={e => this.setState({ lastnameFocus: false })}
                onChange={e => {
                  e = e.target.value;
                  let aux = this.state.customerData;
                  aux.lastname = e;
                  this.setState({ customerData: aux });
                  this.validateField("lastname", e);
                }}
              />
            </InputGroup>
          </Col>
        );
        notEnterpriseFields.push(
          <Col xs={12} sm="6" key="lastname2">
            <InputGroup
              className={
                "form-control-lg " +
                (this.state.fieldStates["lastname2"] || "") +
                (this.state.lastname2Focus ? " input-group-focus" : "")
              }
            >
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="now-ui-icons text_caps-small" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                value={this.state.customerData.lastname2 || ""}
                type="text"
                placeholder="Segundo apellido"
                name="lastname2"
                onFocus={e => this.setState({ lastname2Focus: true })}
                onBlur={e => this.setState({ lastname2Focus: false })}
                onChange={e => {
                  e = e.target.value;
                  let aux = this.state.customerData;
                  aux.lastname2 = e;
                  this.setState({ customerData: aux });
                  this.validateField("lastname2", e);
                }}
              />
            </InputGroup>
          </Col>
        );
      } else {
        managerFields = (
          <Row className="justify-content-center">
            <Col xs={12} sm="12" className="text-center">
              <h5 className="info-text">Datos del gerente</h5>
            </Col>
            <Col xs={12} sm="6">
              <InputGroup
                className={
                  "form-control-lg " +
                  (this.state.fieldStates["dniManager"] || "") +
                  (this.state.dniManagerFocus ? " input-group-focus" : "")
                }
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="now-ui-icons users_circle-08" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.state.customerData.dniManager || ""}
                  type="text"
                  placeholder="DNI/NIE/NIF"
                  name="dniManager"
                  onFocus={e => this.setState({ dniManagerFocus: true })}
                  onBlur={e => this.setState({ dniManagerFocus: false })}
                  onChange={e => {
                    e = e.target.value;
                    let aux = this.state.customerData;
                    aux.dniManager = e;
                    this.setState({ customerData: aux });
                    this.validateField("dniManager", e);
                  }}
                />
              </InputGroup>
            </Col>
            <Col xs={12} sm="6">
              <InputGroup
                className={
                  "form-control-lg " +
                  (this.state.fieldStates["firstnameManager"] || "") +
                  (this.state.firstnameManagerFocus ? " input-group-focus" : "")
                }
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="now-ui-icons users_circle-08" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.state.customerData.firstnameManager || ""}
                  type="text"
                  placeholder="Nombre"
                  name="firstnameManager"
                  onFocus={e => this.setState({ firstnameManagerFocus: true })}
                  onBlur={e => this.setState({ firstnameManagerFocus: false })}
                  onChange={e => {
                    e = e.target.value;
                    let aux = this.state.customerData;
                    aux.firstnameManager = e;
                    this.setState({ customerData: aux });
                    this.validateField("firstnameManager", e);
                  }}
                />
              </InputGroup>
            </Col>
            <Col xs={12} sm="6">
              <InputGroup
                className={
                  "form-control-lg " +
                  (this.state.fieldStates["lastnameManager"] || "") +
                  (this.state.lastnameManagerFocus ? " input-group-focus" : "")
                }
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="now-ui-icons text_caps-small" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.state.customerData.lastnameManager || ""}
                  type="text"
                  placeholder="Primer apellido"
                  name="lastnameManager"
                  onFocus={e => this.setState({ lastnameManagerFocus: true })}
                  onBlur={e => this.setState({ lastnameManagerFocus: false })}
                  onChange={e => {
                    e = e.target.value;
                    let aux = this.state.customerData;
                    aux.lastnameManager = e;
                    this.setState({ customerData: aux });
                    this.validateField("lastnameManager", e);
                  }}
                />
              </InputGroup>
            </Col>
            <Col xs={12} sm="6">
              <InputGroup
                className={
                  "form-control-lg " +
                  (this.state.fieldStates["lastname2Manager"] || "") +
                  (this.state.lastname2ManagerFocus ? " input-group-focus" : "")
                }
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="now-ui-icons text_caps-small" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.state.customerData.lastname2Manager || ""}
                  type="text"
                  placeholder="Segundo apellido"
                  name="lastname2Manager"
                  onFocus={e => this.setState({ lastname2ManagerFocus: true })}
                  onBlur={e => this.setState({ lastname2ManagerFocus: false })}
                  onChange={e => {
                    e = e.target.value;
                    let aux = this.state.customerData;
                    aux.lastname2Manager = e;
                    this.setState({ customerData: aux });
                    this.validateField("lastname2Manager", e);
                  }}
                />
              </InputGroup>
            </Col>
          </Row>
        );
      }
      let basicData = (
        <Card key="customer_basic_data" className="text-center">
          <CardHeader>
            <CardTitle tag="h4" className="text-center">Datos básicos</CardTitle>
          </CardHeader>
          <CardBody className="text-right">
            <Row className="justify-content-center">
              {/* <Col xs={12} sm="6">
                <InputGroup
                  className={
                    "form-control-lg" +
                    (this.state.promoCodeState ? this.state.promoCodeState : "") +
                    (this.state.promoCodeFocus ? " input-group-focus" : "")
                  }
                >
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="now-ui-icons education_atom" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    value={this.state.customerData.promoCode}
                    type="text"
                    placeholder="Código promocional"
                    name="promoCode"
                    onFocus={e => this.setState({ promoCodeFocus: true })}
                    onBlur={e => this.setState({ promoCodeFocus: false })}
                    onChange={e => this.promoCodeChange(e)}
                  />
                </InputGroup>
              </Col> */}
              {fiscalIdTypeField}
              <Col xs={12} sm="6">
                <InputGroup
                  className={
                    "form-control-lg " +
                    (this.state.fieldStates["dni"] || "") +
                    (this.state.dniFocus ? " input-group-focus" : "")
                  }
                >
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="now-ui-icons users_circle-08" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    value={this.state.customerData.dni || ""}
                    type="text"
                    placeholder={this.state.customerData.customerType.value !== "90" ? "DNI/NIE/Pasaporte" : "NIF de la empresa"}
                    name="dni"
                    onFocus={e => this.setState({ dniFocus: true })}
                    onBlur={e => this.setState({ dniFocus: false })}
                    onChange={e => {
                      e = e.target.value;
                      let aux = this.state.customerData;
                      aux.dni = e;
                      this.setState({ customerData: aux });
                      this.validateField("dni", e);
                    }}
                  />
                </InputGroup>
              </Col>
              <Col xs={12} sm="6">
                <InputGroup
                  className={
                    "form-control-lg " +
                    (this.state.fieldStates["firstname"] || "") +
                    (this.state.firstnameFocus ? " input-group-focus" : "")
                  }
                >
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="now-ui-icons users_circle-08" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    value={this.state.customerData.firstname || ""}
                    type="text"
                    placeholder={this.state.customerData.customerType.value !== "90" ? "Nombre" : "Nombre de la empresa"}
                    name="firstname"
                    onFocus={e => this.setState({ firstnameFocus: true })}
                    onBlur={e => this.setState({ firstnameFocus: false })}
                    onChange={e => {
                      e = e.target.value;
                      let aux = this.state.customerData;
                      aux.firstname = e;
                      this.setState({ customerData: aux });
                      this.validateField("firstname", e);
                    }}
                  />
                </InputGroup>
              </Col>
              {notEnterpriseFields}
              <Col xs={12} sm="6">
                <InputGroup
                  className={
                    "form-control-lg " +
                    (this.state.fieldStates["mobile"] || "") +
                    (this.state.mobileFocus ? " input-group-focus" : "")
                  }
                >
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="now-ui-icons tech_mobile" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    value={this.state.customerData.mobile || ""}
                    type="number"
                    placeholder="Móvil"
                    name="mobile"
                    onFocus={e => this.setState({ mobileFocus: true })}
                    onBlur={e => this.setState({ mobileFocus: false })}
                    onChange={e => {
                      e = e.target.value;
                      let aux = this.state.customerData;
                      aux.mobile = e;
                      this.setState({ customerData: aux });
                      this.validateField("mobile", e);
                    }}
                  />
                </InputGroup>
              </Col>
              <Col xs={12} sm="6">
                <InputGroup
                  className={
                    "form-control-lg " +
                    (this.state.fieldStates["email"] || "") +
                    (this.state.emailFocus ? " input-group-focus" : "")
                  }
                >
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="now-ui-icons ui-1_email-85" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    value={this.state.customerData.email || ""}
                    type="email"
                    placeholder="Email"
                    name="email"
                    onFocus={e => this.setState({ emailFocus: true })}
                    onBlur={e => this.setState({ emailFocus: false })}
                    onChange={e => {
                      e = e.target.value;
                      let aux = this.state.customerData;
                      aux.email = e;
                      this.setState({ customerData: aux });
                      this.validateField("email", e);
                    }}
                  />
                </InputGroup>
              </Col>
              <Col xs={12} sm="6">
                <InputGroup
                  className={
                    "form-control-lg " +
                    (this.state.fieldStates["iban"] || "") +
                    (this.state.emailFocus ? " input-group-focus" : "")
                  }
                >
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="now-ui-icons business_bank" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    value={this.state.customerData.iban || ""}
                    type="text"
                    placeholder="IBAN cuenta bancaria"
                    name="iban"
                    onFocus={e => this.setState({ ibanFocus: true })}
                    onBlur={e => this.setState({ ibanFocus: false })}
                    onChange={event => {
                      try {
                        const caret = event.target.selectionStart;
                        const element = event.target;
                        const realCaret = this.formatIBAN(event.target.value.substring(0,caret)).length;
                        window.requestAnimationFrame(() => {
                          element.selectionStart = realCaret;
                          element.selectionEnd = realCaret;
                        });
                      } catch (e) {}
  
                      let newIBAN = this.formatIBAN(event.target.value);
                      let aux = this.state.customerData;
                      aux.iban = newIBAN;
                      this.setState({ customerData: aux });
                      this.validateField("iban", newIBAN);
                    }}
                  />
                </InputGroup>
              </Col>
            </Row>
            {managerFields}
          </CardBody>
        </Card>
      );
      return basicData;
    } catch (error) {
      return null;
    }
  }
  buildCustomerAddress() {
    try {
      let customerAddress = (
        <Card key="customer_address" className="text-center" >
          <CardHeader>
            <CardTitle tag="h4" className="text-center">Dirección</CardTitle>
          </CardHeader>
          <CardBody className="text-right">
            <Row around="xs" className="align-items-center">
            <Col xs={12} sm="12">
              <InputGroup
                className={
                  "form-control-lg " +
                  (this.state.fieldStates["street"] || "") +
                  (this.state.streetFocus ? " input-group-focus" : "")
                }
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="now-ui-icons business_badge" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.state.customerData.street || ""}
                  type="text"
                  placeholder="Dirección (Calle, número...)"
                  name="street"
                  onFocus={e => this.setState({ streetFocus: true })}
                  onBlur={e => this.setState({ streetFocus: false })}
                  onChange={e => {
                    e = e.target.value;
                    let aux = this.state.customerData;
                    aux.street = e;
                    this.setState({ customerData: aux });
                    this.validateField("street", e);
                  }}
                />
              </InputGroup>
            </Col>
            <Col xs={12} sm="6">
              <InputGroup
                className={
                  "form-control-lg " +
                  (this.state.fieldStates["locality"] || "") +
                  (this.state.cityFocus ? " input-group-focus" : "")
                }
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="now-ui-icons location_compass-05" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.state.customerData.locality || ""}
                  type="text"
                  placeholder="Localidad"
                  name="locality"
                  onFocus={e => this.setState({ cityFocus: true })}
                  onBlur={e => this.setState({ cityFocus: false })}
                  onChange={e => {
                    e = e.target.value;
                    let aux = this.state.customerData;
                    aux.locality = e;
                    this.setState({ customerData: aux });
                    this.validateField("locality", e);
                  }}
                />
              </InputGroup>
            </Col>
            <Col xs={12} sm="6">
              <InputGroup
                className={
                  "form-control-lg " +
                  (this.state.fieldStates["postalCode"] || "") +
                  (this.state.postalCodeFocus ? " input-group-focus" : "")
                }
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="now-ui-icons location_pin" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.state.customerData.postalCode || ""}
                  type="number"
                  placeholder="Código postal"
                  name="postalCode"
                  onFocus={e => this.setState({ postalCodeFocus: true })}
                  onBlur={e => this.setState({ postalCodeFocus: false })}
                  onChange={e => {
                    e = e.target.value;
                    let aux = this.state.customerData;
                    aux.postalCode = e;
                    this.setState({ customerData: aux });
                    this.validateField("postalCode", e);
                  }}
                />
              </InputGroup>
            </Col>
            <Col xs={12} sm="6">
              <InputGroup
                className={
                  "form-control-lg " +
                  (this.state.fieldStates["province"] || "") +
                  (this.state.provinceFocus ? " input-group-focus" : "")
                }
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="now-ui-icons location_map-big" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.state.customerData.province || ""}
                  type="text"
                  placeholder="Provincia"
                  name="province"
                  onFocus={e => this.setState({ provinceFocus: true })}
                  onBlur={e => this.setState({ provinceFocus: false })}
                  onChange={e => {
                    e = e.target.value;
                    let aux = this.state.customerData;
                    aux.province = e;
                    this.setState({ customerData: aux });
                    this.validateField("province", e);
                  }}
                />
              </InputGroup>
            </Col>
            <Col xs={12} sm="6">
              <InputGroup
                className={
                  "form-control-lg " +
                  (this.state.fieldStates["comunity"] || "") +
                  (this.state.comunityFocus ? " input-group-focus" : "")
                }
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="now-ui-icons location_world" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  value={this.state.customerData.comunity || ""}
                  type="text"
                  placeholder="Comunidad Autónoma"
                  name="comunity"
                  onFocus={e => this.setState({ comunityFocus: true })}
                  onBlur={e => this.setState({ comunityFocus: false })}
                  onChange={e => {
                    e = e.target.value;
                    let aux = this.state.customerData;
                    aux.comunity = e;
                    this.setState({ customerData: aux });
                    this.validateField("comunity", e);
                  }}
                />
              </InputGroup>
            </Col>
            </Row>
          </CardBody>
        </Card>
      );
      return customerAddress;
    } catch (error) {
      return null;
    }
  }
  setFrontIdentificationDocumentImage(image) {
    let aux = this.state.identificationDocuments;
    aux.front = image;
    this.setState({ identificationDocuments: aux });
  }
  setBackIdentificationDocumentImage(image) {
    let aux = this.state.identificationDocuments;
    aux.back = image;
    this.setState({ identificationDocuments: aux });
  }
  setNifIdentificationDocumentImage(image) {
    let aux = this.state.identificationDocuments;
    aux.nif = image;
    this.setState({ identificationDocuments: aux });
  }
  buildCustomerSignature() {
    try {
      let signatureField = (
        <Card key="signatureField" className="text-center" >
          <CardHeader>
            <CardTitle tag="h4" className="text-center">Firma</CardTitle>
          </CardHeader>
          <CardBody className="text-right">
            <Row around="xs" className="align-items-center">
              <Col xs={12}>
                <SignatureCanvas 
                  ref={(ref) => { this.signature = ref }}
                  // ref="signature"
                  penColor="black"
                  canvasProps={{width: window.innerWidth - 90, height: 250, className: 'sigCanvas'}} 
                  onEnd={this.saveSignature}
                  clearOnResize={false}
                  /> 
              </Col>
              <Col xs={12}>
                {this.state.signature && <Button
                  color="default"
                  size="lg"
                  onClick={() => {
                    this.clearSignature();
                  }}
                >
                  {"Borrar firma"}
                </Button>}
              </Col>
            </Row>
          </CardBody>
        </Card>
      );
      let identificationDocuments = (
        <Card key="identificationDocumentsField" className="text-center justify-content-center">
          <CardHeader>
            <CardTitle tag="h4" className="text-center">Documento de identificación</CardTitle>
          </CardHeader>
          <CardBody>
            <Row>
              <Col xs={12}>
                <Row>
                  <Col xs={12} sm={6} md={6}>
                    <CardTitle tag="h6">Cara delantera</CardTitle>
                    <ImageUpload 
                      getImage={this.setFrontIdentificationDocumentImage.bind(this)} 
                      existingImage={this.state.identificationDocuments.front}
                    />
                  </Col>
                  <Col xs={12} sm={6} md={6}>
                    <CardTitle tag="h6">Cara trasera</CardTitle>
                    <ImageUpload 
                      getImage={this.setBackIdentificationDocumentImage.bind(this)}
                      existingImage={this.state.identificationDocuments.back} 
                    />
                  </Col>
                {((this.state.customerData && this.state.customerData.customerType && this.state.customerData.customerType.value === "90") || this.state.contract.is_company) && 
                  <Col xs={12} sm={6} md={6}>
                    <CardTitle tag="h6">NIF Empresa</CardTitle>
                    <ImageUpload 
                      getImage={this.setNifIdentificationDocumentImage.bind(this)}
                      existingImage={this.state.identificationDocuments.nif} 
                    />
                  </Col>}
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>
      );
      return [identificationDocuments, signatureField];
    } catch (error) {
      console.log("Error al mostrar documentos y firma", error);
      return null;
    }
  }
  buildContent(alreadySigned) {
    let content = null;
    if (!alreadySigned) { 
      switch (this.state.currentStep) {
        case PRODUCTOS:
          content = this.buildContractProducts();
          break;
        case TIPO_CLIENTE:
          content = this.buildCustomerType();
          break;
        case DATOS_BASICOS:
          content = this.buildCustomerBasicData();
          break;
        case DIRECCION:
          content = this.buildCustomerAddress();
          break;
        case FIRMA:
          content = this.buildCustomerSignature();
          break;
        default:
          break;
      }
    } else {
      content = this.buildSignedContent();
    }
    return content;
  }
  buildSignedContent() {
    let contractProducts = this.buildContractProducts();
    let customerType = null;
    let customerBasicData = null;
    let customerAddress = null;
    let customerSignatureAndDocuments = this.buildCustomerSignature();

    if (Object.keys(this.state.customerData).length > 0) {
      customerType = this.buildCustomerType();
      customerBasicData = this.buildCustomerBasicData();
      customerAddress = this.buildCustomerAddress();
    }
    return [
      this.buildContractProducts(), 
      customerType, 
      customerBasicData, 
      customerAddress,
      this.buildCustomerSignature()
    ];
  }
  clearSignature() {
    if(this.signature) this.signature.clear();
    this.setState({signature: null});
  }
  buildExistingCustomer() {
    let result = null;

    if (this.state.existingCustomer) {
      if (this.state.existingCustomer in this.props.mainState.customers) {
        let existingCustomer = this.props.mainState.customers[this.state.existingCustomer];
        let customersToDisplay = [];
        customersToDisplay[this.state.existingCustomer] = existingCustomer;

        result = (
          <Row className="justify-content-center">
            <Col xs={12}>
              <Card className="text-center text-black" color="warning">
                <CardHeader>
                  <CardTitle tag="h4" className="text-center text-black">Cliente existente</CardTitle>
                </CardHeader>
                <CardBody>
                  <Table responsive>
                    <thead>
                      <tr className="text-black">
                        {theadcustomers.map((prop, key) => {
                          if (prop === "Distribuidor") return null;
                          if (prop === "Estado") return null;
                          if (key === theadcustomers.length - 1)
                            return (
                              <th key={key} className="text-left">
                                {prop}
                              </th>
                            );
                          return (
                            <th key={key} className="text-left">
                              {prop}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(customersToDisplay)
                        .sort(function(a, b) {
                          return b - a;
                        })
                        .map((customerKey, key) => {
                          let customer = customersToDisplay[customerKey][0];
                          // let servicesButtons = this.createServicesButtons(
                          //   customer
                          // );
                          // let activeCustomerButton = this.createActiveCustomerButton(
                          //   customer
                          // );
                          let formattedNumber = "";
                          if (customer.phone) {
                            formattedNumber =
                              customer.phone.substring(0, 3) +
                              " " +
                              customer.phone.substring(3, 6) +
                              " " +
                              customer.phone.substring(6, 9);
                          }
                          return (
                            <tr key={customer.id}>
                              {/* <td className="text-center">
                                {activeCustomerButton}
                              </td> */}
                              <td className="text-left">{customer.creacion}</td>
                              <td className="text-left">
                                <Link to={"/clientes/fichas/".concat(customer.id)} className="text-white">
                                  {customer.nombre_completo}{" "}
                                  {customer.primer_apellido}{" "}
                                  {customer.segundo_apellido}
                                </Link>
                              </td>
                              <td className="text-left">{formattedNumber}</td>
                              <td className="text-left">{customer.nif}</td>
                              {/*<td className="text-left">{customer.email}</td>*/}
                              <td className="text-left">{customer.domicilio}</td>
                              <td className="text-left">{customer.localidad}</td>
                              {/* <td className="text-left">{customer.distribuidor}</td> */}
                              {/* <td className="text-center">{servicesButtons}</td> */}
                              {/* order.data.map((prop, key) => {
                                if (key === thead.length - 1)
                                  return (
                                    <td key={key} className="text-right">
                                      {prop}
                                    </td>
                                  );
                                return <td key={key}>{prop}</td>;
                              }) */}
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        );
      } else {
        result = (
          <Row>
            <Col xs={12}>
              <Card className="text-center text-black" color="warning">
                <CardHeader>
                  <CardTitle tag="h4" className="text-center text-black">Cliente existente</CardTitle>
                </CardHeader>
                <CardBody>
                  <div className="text-center">
                    <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando datos del cliente...
                  </div>
                  <br />
                </CardBody>
              </Card>
            </Col>
          </Row>
        );
      }
    }

    return result;
  }
  createCustomer(contract) {
    this.props.createCustomerFromContract(contract);
    this.redirectTo("/clientes/crear");
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  goBack(){
    try {
      this.props.cleanContract();
      if(this.state.contract.existing_customer) {
        this.redirectTo("/clientes/fichas/" + this.state.contract.existing_customer);
      } else {
        this.redirectTo("/contratos");
      }
    } catch (error) {
      this.props.cleanContract();
    }
  }
  render() {
    if (this.state.toContractList === true) {
      this.goBack();
      // this.redirectTo("/contratos");
      // return <Redirect to="/contratos" />;
    }
    if (this.state.goToContracts === true) {
      this.goBack();
      // this.redirectTo("/contratos");
      // return <Redirect to="/contratos" />;
    }
    // console.log("###### state ######");
    // console.log(this.state);
    if (this.state.contractLoaded){
        let contentToDisplay = null;
        let internetProducts = [];
        let packProducts = [];
        let othersProducts = [];
        let mobileProducts = [];
        let contract = this.state.contract;
        let alreadySigned = (parseInt(contract.status) === 230 || parseInt(contract.status) === 231);
        let footer = this.buildFooter(alreadySigned);
        productsAvailable.map(product => {
        switch (product.type) {
            case INTERNET:
            internetProducts.push(product);
            break;
            case PACK:
            packProducts.push(product);
            break;
            case MOVIL:
            mobileProducts.push(product);
            break;
            default:
            othersProducts.push(product);
            break;
        }
        });
        // let leftProducts = this.buildProductsCards(internetProducts, packProducts, othersProducts, mobileProducts);
        let contractProducts = this.buildContent(alreadySigned);
        let existingCustomer = this.buildExistingCustomer();
        contentToDisplay = 
          <Row className="justify-content-center">
              <Col xs={12}>
              {contractProducts}
              </Col>
          </Row>;
        let createCustomer = null;
        // console.log("Contrato cargado", contract);
        if(parseInt(contract.status) === 230) {
          createCustomer = (
            <Button
              key={"createClientButton" + contract.id}
              color="primary"
              size="lg"
              block
              // icon
              onClick={e =>
                this.createCustomer(contract)
              } 
              style={{ marginTop: "40px" }}
            >
              <div>
                <i className="now-ui-icons ui-1_simple-add" /> Crear ficha
              </div>
            </Button>
          );
        }
        if (!this.state.isSigningContract) {
            return (
            <div>
                <PanelHeader size="sm" />
                <div className="content text-center">
                  {existingCustomer}
                  {createCustomer}
                  {contentToDisplay}
                  {footer}
                </div>
            </div>
            );
        } else {
            return (
            <div>
                <PanelHeader size="sm" />
                <div className="content text-center">
                <Card color="primary" style={{ margin: 0 }}>
                    <CardHeader></CardHeader>
                    <CardBody className="text-center">
                    <div>
                        <div className="text-center">
                        <br />
                        <h5><i className="now-ui-icons arrows-1_refresh-69 spin" /> Firmando</h5>
                        </div>
                    </div>
                    </CardBody>
                    <CardFooter></CardFooter>
                </Card>
                </div>
            </div>
            );
        }
    } else {
        return (
            <div>
                <PanelHeader size="sm" />
                <div className="content text-center">
                <Card color="primary" style={{ margin: 0 }}>
                    <CardHeader></CardHeader>
                    <CardBody className="text-center">
                    <div>
                        <div className="text-center">
                        <br />
                        <h5><i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando</h5>
                        </div>
                    </div>
                    </CardBody>
                    <CardFooter></CardFooter>
                </Card>
                </div>
            </div>
        );
    }
  }
}

export default ViewContract;



// WEBPACK FOOTER //
// ./src/views/Contracts/ViewContract.jsx